import { useMessage } from "../../../hooks/useMessage";
import {
  DELETE,
  MAINTENANCE_DELETE,
  RESERVATION_DELETE,
} from "../../../services";

export const useDelete = () => {
  const { openMessage } = useMessage();

  const onDelete = async (
    maintainId: string,
    remark = ""
  ): Promise<boolean> => {
    try {
      const res = await DELETE(MAINTENANCE_DELETE(maintainId, remark));
      openMessage("success", res.message);
      return true;
    } catch (error: any) {
      console.log(error);
      openMessage("error", error.error);
      return false;
    }
  };

  return {
    onDelete,
  };
};
